// Added by Sejune Oh on 2020-04-09
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react'
import {
  DialogTitle as MaterialUIDialogTitle,
  DialogTitleProps as MaterialUIDialogTitleProps,
} from '@material-ui/core'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
interface DialogTitleBaseProps {}
export type DialogTitleProps = MaterialUIDialogTitleProps & DialogTitleBaseProps

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const DialogTitle:FC<DialogTitleProps> = ({...props}) => {
    return <MaterialUIDialogTitle {...props} />
}
